import { Table } from "components";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {  VideoViewCountTableColumns } from "./components/VideoViewCountTableColumns";
import { fetchVideoViewCount } from "modules/video/video_detail/store/action";
import { videoViewCountColumnVisibility } from "./components/videoViewCountColumnVisibility";
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const VideoViewCountTable: React.FC<Props> = ({
  videoDetailsState,
  onFetchVideoView,
  // onResetDcddData
}) => {
 const [displayedData, setDisplayedData] = useState<any[]>([]);
const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const rmaPaymentData = videoDetailsState?.viewCount;
  useEffect(() => {
    onFetchVideoView()
  }, [onFetchVideoView]);
  const downloadCSV = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const csvRows = [
      headers.join(","), // header row
      ...data.map((row) =>
        headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
      ),
    ];
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "stripe_payment.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Video_View.xls";
    document.body.appendChild(link);
    link.click()
    document.body.removeChild(link);
  };
  
  const downloadPDF = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(
      "<html><head><title>Vidoe View</title></head><body>"
    );
    printWindow.document.write("<h1>Video View Count</h1>");

    // Assuming you want to print the table as HTML
    const tableHTML = document.querySelector("table")?.outerHTML;
    if (tableHTML) {
      printWindow.document.write(tableHTML);
    } else {
      printWindow.document.write("<p>No data available</p>");
    }

    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <>
      <Table
        headers={["Report", "Video View Count"]}
        data={rmaPaymentData}
        columnVisibilityItems={videoViewCountColumnVisibility}
        tableColumns={VideoViewCountTableColumns}
        addButton={
          <div>
            <button
              className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
              onClick={() => downloadExcel(rmaPaymentData)}
            >
              Download Excel
            </button>
          </div>
        }
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    videoDetailsState: state.videoDetails?.videoDetailsState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoView: () => dispatch(fetchVideoViewCount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoViewCountTable);
